import React from 'react';
import { AlertCircleIcon, CheckCircleIcon, ClockIcon, FileTextIcon, PlusCircleIcon, TrendingUpIcon, UserIcon } from 'lucide-react';
export function VendorDashboard({
  vendor,
  onViewInvoice
}) {
  // Early return if vendor is not available
  if (!vendor) {
    return <div className="p-6" data-id="element-1047">
        <div className="text-center" data-id="element-1048">
          <FileTextIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-1049" />
          <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-1050">
            Loading vendor data
          </h3>
          <p className="mt-1 text-sm text-gray-500" data-id="element-1051">
            Please wait while we fetch your information.
          </p>
        </div>
      </div>;
  }
  // Sample data for the dashboard
  const invoiceStats = {
    total: 12,
    pending: 3,
    approved: 7,
    paid: 2
  };
  const recentInvoices = [{
    id: 'INV-2023-001',
    date: '2023-10-15',
    amount: 1250.75,
    status: 'Pending Approval'
  }, {
    id: 'INV-2023-002',
    date: '2023-10-10',
    amount: 3430.0,
    status: 'Approved'
  }, {
    id: 'INV-2023-003',
    date: '2023-10-05',
    amount: 2100.5,
    status: 'Paid'
  }];
  const getStatusIcon = status => {
    switch (status) {
      case 'Pending Approval':
        return <ClockIcon className="h-5 w-5 text-yellow-500" data-id="element-1052" />;
      case 'Approved':
        return <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-1053" />;
      case 'Paid':
        return <TrendingUpIcon className="h-5 w-5 text-blue-500" data-id="element-1054" />;
      case 'Rejected':
        return <AlertCircleIcon className="h-5 w-5 text-red-500" data-id="element-1055" />;
      default:
        return <FileTextIcon className="h-5 w-5 text-gray-500" data-id="element-1056" />;
    }
  };
  return <div data-id="element-1057">
      <div className="mb-8" data-id="element-1058">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1059">
          Welcome, {vendor.name}
        </h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-1060">
          Here's an overview of your invoices and recent activity
        </p>
      </div>
      {/* Stats Cards */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1061">
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-1062">
          <div className="p-5" data-id="element-1063">
            <div className="flex items-center" data-id="element-1064">
              <div className="flex-shrink-0" data-id="element-1065">
                <FileTextIcon className="h-6 w-6 text-gray-400" data-id="element-1066" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-1067">
                <dl data-id="element-1068">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-1069">
                    Total Invoices
                  </dt>
                  <dd data-id="element-1070">
                    <div className="text-lg font-medium text-gray-900" data-id="element-1071">
                      {invoiceStats.total}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-1072">
          <div className="p-5" data-id="element-1073">
            <div className="flex items-center" data-id="element-1074">
              <div className="flex-shrink-0" data-id="element-1075">
                <ClockIcon className="h-6 w-6 text-yellow-400" data-id="element-1076" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-1077">
                <dl data-id="element-1078">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-1079">
                    Pending Approval
                  </dt>
                  <dd data-id="element-1080">
                    <div className="text-lg font-medium text-gray-900" data-id="element-1081">
                      {invoiceStats.pending}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-1082">
          <div className="p-5" data-id="element-1083">
            <div className="flex items-center" data-id="element-1084">
              <div className="flex-shrink-0" data-id="element-1085">
                <CheckCircleIcon className="h-6 w-6 text-green-400" data-id="element-1086" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-1087">
                <dl data-id="element-1088">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-1089">
                    Approved
                  </dt>
                  <dd data-id="element-1090">
                    <div className="text-lg font-medium text-gray-900" data-id="element-1091">
                      {invoiceStats.approved}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-1092">
          <div className="p-5" data-id="element-1093">
            <div className="flex items-center" data-id="element-1094">
              <div className="flex-shrink-0" data-id="element-1095">
                <TrendingUpIcon className="h-6 w-6 text-blue-400" data-id="element-1096" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-1097">
                <dl data-id="element-1098">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-1099">
                    Paid
                  </dt>
                  <dd data-id="element-1100">
                    <div className="text-lg font-medium text-gray-900" data-id="element-1101">
                      {invoiceStats.paid}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Recent Invoices */}
      <div className="mt-8" data-id="element-1102">
        <div className="flex items-center justify-between mb-4" data-id="element-1103">
          <h2 className="text-lg font-medium text-gray-900" data-id="element-1104">Recent Invoices</h2>
          <button onClick={() => onViewInvoice(null)} className="inline-flex items-center px-3 py-1 border border-transparent text-sm font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-1105">
            View All
          </button>
        </div>
        <div className="bg-white shadow overflow-hidden sm:rounded-md" data-id="element-1106">
          <ul className="divide-y divide-gray-200" data-id="element-1107">
            {recentInvoices.map(invoice => <li key={invoice.id} data-id="element-1108">
                <a href="#" onClick={e => {
              e.preventDefault();
              onViewInvoice(invoice);
            }} className="block hover:bg-gray-50" data-id="element-1109">
                  <div className="px-4 py-4 sm:px-6" data-id="element-1110">
                    <div className="flex items-center justify-between" data-id="element-1111">
                      <div className="flex items-center" data-id="element-1112">
                        {getStatusIcon(invoice.status)}
                        <p className="text-sm font-medium text-indigo-600 truncate ml-2" data-id="element-1113">
                          {invoice.id}
                        </p>
                      </div>
                      <div className="ml-2 flex-shrink-0 flex" data-id="element-1114">
                        <p className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-1115">
                          {invoice.status}
                        </p>
                      </div>
                    </div>
                    <div className="mt-2 sm:flex sm:justify-between" data-id="element-1116">
                      <div className="sm:flex" data-id="element-1117">
                        <p className="flex items-center text-sm text-gray-500" data-id="element-1118">
                          Submitted on {invoice.date}
                        </p>
                      </div>
                      <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-1119">
                        <p className="font-medium text-gray-900" data-id="element-1120">
                          ${invoice.amount.toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </li>)}
          </ul>
        </div>
      </div>
      {/* Quick Actions */}
      <div className="mt-8" data-id="element-1121">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1122">
          Quick Actions
        </h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-1123">
          <div className="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500" data-id="element-1124">
            <div className="flex-shrink-0" data-id="element-1125">
              <PlusCircleIcon className="h-6 w-6 text-indigo-600" data-id="element-1126" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-1127">
              <a href="#" onClick={e => {
              e.preventDefault();
              // Navigate to upload invoice view
            }} className="focus:outline-none" data-id="element-1128">
                <span className="absolute inset-0" aria-hidden="true" data-id="element-1129" />
                <p className="text-sm font-medium text-gray-900" data-id="element-1130">
                  Upload New Invoice
                </p>
                <p className="text-sm text-gray-500" data-id="element-1131">
                  Submit a new invoice for processing
                </p>
              </a>
            </div>
          </div>
          <div className="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500" data-id="element-1132">
            <div className="flex-shrink-0" data-id="element-1133">
              <UserIcon className="h-6 w-6 text-indigo-600" data-id="element-1134" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-1135">
              <a href="#" onClick={e => {
              e.preventDefault();
              // Navigate to profile view
            }} className="focus:outline-none" data-id="element-1136">
                <span className="absolute inset-0" aria-hidden="true" data-id="element-1137" />
                <p className="text-sm font-medium text-gray-900" data-id="element-1138">
                  Update Profile
                </p>
                <p className="text-sm text-gray-500" data-id="element-1139">
                  Manage your account details
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
}